import { useEffect } from 'react';
import { CustomEventService, IEvents } from '@mfe-helpers/customEvent';
import { composeGenericDatalayer } from '@mfe-helpers/tracking';
import { useAppContext } from '@mfe-presentation/contexts';
import { useLocale } from '@aviv-unified-frontend/runtime/i18n';

const useSetDatalayer = () => {
    const { portal } = useAppContext();
    const { locale } = useLocale();

    useEffect(() => {
        CustomEventService.fire(IEvents.SET_DATALAYER, composeGenericDatalayer({ portal, locale }));
    }, []);
};

export default useSetDatalayer;
